export const creditCardConfig = {
  creditCard: {
    installmentRules: [
      {
        minValue: 0,
        maxInstallments: 1,
      },
      {
        minValue: 50,
        maxInstallments: 2,
      },
      {
        minValue: 100,
        maxInstallments: 3,
      },
      {
        minValue: 200,
        maxInstallments: 4,
      },
      {
        minValue: 1000,
        maxInstallments: 6,
      },
    ],
  },
};
